import { Trans } from "@lingui/react";
import { WIcon } from "@mobility-item-page/client";
import { Button } from "@warp-ds/elements/react/button";
import { ScreenReaderSeparator } from "../components/ScreenReaderSeparator.tsx";
import { useValidDealerItemContext } from "../context/DealerItemProviderContext.tsx";
import { useTracking } from "../utils/pulseHelper.ts";

export const DeepLinkAction = () => {
  const {
    itemData: { externalItemUrl },
    external: { isPreview },
  } = useValidDealerItemContext();
  if (externalItemUrl) {
    return <ExternalItem key="external" externalItemUrl={externalItemUrl} isPreview={isPreview} />;
  }
  return null;
};

const ExternalItem = ({ externalItemUrl, isPreview = false }: { externalItemUrl: string; isPreview?: boolean }) => {
  const { trackGoToItem } = useTracking();

  if (isPreview) {
    return (
      <Button variant="secondary" data-testid="external-item" fullWidth className="whitespace-nowrap">
        <span className="flex items-center">
          <Trans id="dealer.actions.deeplink" message="View ad on seller's page" />
          <ScreenReaderSeparator />
          <WIcon name="LinkExternal" className="ml-4" />
        </span>
      </Button>
    );
  }

  return (
    <Button
      variant="secondary"
      data-testid="external-item"
      fullWidth
      href={externalItemUrl}
      target="_blank"
      rel="noopener sponsored"
      onClick={trackGoToItem}
    >
      <span className="flex items-center whitespace-nowrap">
        <Trans id="dealer.actions.deeplink" message="View ad on seller's page" />
        <ScreenReaderSeparator />
        <WIcon name="LinkExternal" className="ml-4" />
      </span>
    </Button>
  );
};
